export class AppState {

    private static _instance: AppState;
    private _nativeAppVersion: string;
    private _nativeAppName: string;
    private _nativePackageName: string;
    private _nativePlatformType: string;
    private _nativePushNotificationToken: string;

    private constructor() {
    }

    public get nativeAppVersion(): string {
        return this._nativeAppVersion;
    }

    public set nativeAppVersion(value: string) {
        this._nativeAppVersion = value;
    }

    public get nativeAppName(): string {
        return this._nativeAppName;
    }

    public set nativeAppName(value: string) {
        this._nativeAppName = value;
    }

    public get nativePackageName(): string {
        return this._nativePackageName;
    }

    public set nativePackageName(value: string) {
        this._nativePackageName = value;
    }

    public get nativePlatformType(): string {
        return this._nativePlatformType;
    }

    public set nativePlatformType(value: string) {
        this._nativePlatformType = value;
    }

    public get nativePushNotificationToken(): string {
        return this._nativePushNotificationToken;
    }

    public set nativePushNotificationToken(value: string) {
        this._nativePushNotificationToken = value;
    }

    public static instance(): AppState {
        return this._instance || (this._instance = new this());
    }
}
